module.exports = __webpack_public_path__ + "background.1.56fac4ac39fa1a57eaaf.jpg";


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/assets/img/background.1.jpg
// module id = ../../../../../src/assets/img/background.1.jpg
// module chunks = main